import classNames from "classnames";
import React, { FC } from "react";
import { MdOutlineEmail } from "react-icons/md";
import ShareIcon from "./ShareIcon";

type EmailShareIconProps = {
  color?: string;
};

const EmailShareIcon: FC<EmailShareIconProps> = ({ color }) => {
  const subjectLine = "Detta måste du se!";
  const style: any = { height: "30px", width: "30px" };
  if (color) style.color = color;

  return (
    <ShareIcon
      className={classNames("text-green")}
      urlPrefix={`mailto:?subject=${encodeURI(subjectLine)}&body=`}
    >
      <MdOutlineEmail style={style} />
    </ShareIcon>
  );
};

export default EmailShareIcon;
